<template>
    <div class="loader-area" v-if="isLoading">
        <div class="loader">
        </div>
    </div>
</template>

<script>
export default {
    name:"Loader",

    props:["isLoading"]
}
</script>
<style>
.loader-area{
    position: absolute;
    width: calc(100vw - 80px);
    height: calc(100vh - 75px); /* fallback if css var is not supported*/
    height: calc(calc(var(--vh, 1vh) * 100) - 75px);
    left: 80px;
    background-color: rgba(98, 144, 181, 0.6);
    z-index: 9;
    margin-top: 75px;
}
.loader {
    top: 50%;
    left: 50%;
    position: fixed;
    display: block;
    opacity: 0.7;
    background-color: transparent;
    z-index: 99;
    text-align: center;
    border: 8px solid #f3f3f3;
    border-radius: 50%;
    border-top: 8px solid #133d5e;
    width: 70px;
    height: 70px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    transform: translate(-50%, -50%);
    line-height: 152px
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>

